import React, { Component } from "react";
import Layout from "./Layout";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faEdit,
  faTrash,
  faPlusCircle,
  faPencilAlt,
  faCheck,
  faFilePdf,
} from "@fortawesome/free-solid-svg-icons";
import ReactTooltip from "react-tooltip";
import { NavLink } from "react-router-dom";
import { Button, Col, Modal, Row } from "react-bootstrap";
import ReportePDF from "./formatos/ReportePDF";
import ReportePDFAmbito from "./ReportePDFAmbito";

export default class Escritorio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      modalFinaliza: false,
      finalizaAmbito: null,
      descendientes: [],
      ambitos: [],
      formatos: [],
    };
  }

  componentDidMount = () => {
    this.cargaTabla()
    this.cargaDescendientes()
  };

  componentDidUpdate() {
    ReactTooltip.rebuild();
  }

  cargaDescendientes = () => {
    localStorage.ambitos
      .split(",")
      .map((ambito) => {
        axios({
          method: "get",
          url:
            "http://143.198.191.211/api/Ambito/descendientes/" +
            ambito +
            "?api_token=" +
            localStorage.api_token,
          data: {},
        }).then((res) => {
          let descendientes = []
          res.data.desendientes.forEach(element => {
            descendientes.push(element)
          });
          this.setState({ descendientes: descendientes })
        });
      })

  }

  cargaTabla = () => {
    this.setState({ loading: true });
    axios({
      method: "get",
      url:
        "http://143.198.191.211/api/Ambito?api_token=" +
        localStorage.api_token,
      data: {},
    }).then((res) => {
      this.setState({ ambitos: res.data, loading: false });
    });

    axios({
      method: "get",
      url:
        "http://143.198.191.211/api/anexoClaveNombre?api_token=" +
        localStorage.api_token,
      data: {},
    }).then((res) => {
      this.setState({ formatos: res.data });
    });
  };

  render() {
    return (
      <div>
        <Layout>
          <div className="container mt-3">
            <div className="row">
              <div className="col-12">
                <h1 className="d-inline">Escritorio </h1>{" "}
                <small className="text-muted">
                  {" "}
                  Areas y anexo asignados a {
                    localStorage.nombrecompleto
                  }.{" "}
                </small>
                <h3></h3>
              </div>
              <br></br>
              <table className="table normal">
                <thead>
                  <tr>
                    <th style={{ width: "50px" }}>Cve</th>
                    <th>Ámbito</th>
                    <th style={{ width: "130px", textAlign: "center", padding: "2px" }}></th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.descendientes &&
                    this.state.descendientes
                      .map((ambito) => (
                        <React.Fragment key={ambito.id}>
                          <tr className={localStorage.ambitos.includes(ambito.id) ? "ambito-propio" : "ambito-ageno"}>
                            <td style={{ borderBottom: "1px solid #dfd7ca" }}>{ambito.id}</td>
                            <td>
                              {ambito.ente}{" "}/{" "}
                              {ambito.nivel === 1 ? /*ultima rama */ " " : null}
                              {ambito.nivel === 2 ? (
                              /*ultima rama */ <strong>{ambito.dirgral}</strong>
                              ) : (
                                ambito.dirgral
                              )}
                              {ambito.nivel === 3 ? /*ultima rama */ " " : null}
                              {ambito.dir ? " / " + ambito.dir : null}
                              {ambito.nivel === 4 ? /*ultima rama */ " " : null}
                              {ambito.depto ? " / " + ambito.depto : null}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              <ReportePDFAmbito ambito={ambito} cargaTabla={() => this.cargaTabla()} cargaDescendientes={() => this.cargaDescendientes()} />
                            </td>
                          </tr>
                          {ambito.formatos === null
                            ? null
                            : ambito.formatos.split(",").map((formato) => (
                              formato == ''
                                ? null
                                :
                                <tr key={ambito.id + "-" + formato + Math.random()} className={localStorage.ambitos.includes(ambito.id) ? "ambito-propio" : "ambito-ageno"}>
                                  <td style={{ borderTop: "none" }}></td>
                                  <td>
                                    <NavLink
                                      to={
                                        "f" + formato + "s/ambito/" + ambito.id
                                      }
                                    >
                                      {formato} {this.state.formatos[formato]}
                                    </NavLink>{" "}
                                  </td>
                                  <td style={{ textAlign: "center", padding: "2px" }}>
                                    <ReportePDF
                                      data-tip={"Descarga PDF anexo " + formato + " ámbito " + ambito.id}
                                      style={{ padding: "2px 10px" }}
                                      ambito_id={ambito.id}
                                      anexo={formato} />
                                  </td>
                                </tr>
                            ))}
                        </React.Fragment>
                      ))}
                </tbody>
              </table>
            </div>
          </div>
        </Layout >
        <ReactTooltip />
      </div >
    );
  }
}
